export default __webpack_public_path__ + "static/media/cp_geo_in.e739b194.svg";